import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import {Link} from 'react-router';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';

import connect from '../../utils/connect';

import { fetchSingleEditorial } from '../../actions/editorials';

import EditorialHeader from '../../components/editorial/header/header';
import EditorialContent from '../../components/editorial/content/content';

import ContextualMenu from '../../components/contextual/contextual';

//import css from './editorial.scss';

class NewsSingle extends Component {

	constructor(props) {
		super();
	}

	componentWillMount() {
		//console.log('editorial will mount');
		this.fetchSingle = bindActionCreators(fetchSingleEditorial, this.props.dispatch);

		if (
			this.props.routeParams.slug &&
			this.props.routeParams.slug !== this.props.editorials.single.slug
		) {
			this.fetchSingle(this.props.routeParams.slug);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
			this.fetchSingle(nextProps.routeParams.slug);
		}
	}

	render() {
		if (this.props.editorials && this.props.editorials.single && this.props.editorials.single.id) {
			let editorial = this.props.editorials.single;

			return (
				<article className='cf margin-bottom-contextual'>
					<Helmet title={`The FWA - ${this.getTitle()}`} />
					<EditorialHeader editorial={editorial} browser={this.props.browser} />
					<EditorialContent editorial={editorial} browser={this.props.browser} />
					<div className='cf'></div>
					<ContextualMenu newsId={this.props.editorials.single.id} enableNews={true} />
				</article>
			);
		} else {
			return (
				<div>
					<Helmet title={`The FWA - ${this.getTitle()}`} />
					<Spinner className='case-single__spinner' size='80px'></Spinner>
				</div>
			);
		}
	}

	getTitle() {
		if (this.props.editorials && this.props.editorials.single && this.props.editorials.single.title) {
			return this.props.editorials.single.title;
		}

		return 'News';
	}
}

export default connect(NewsSingle);



/** WEBPACK FOOTER **
 ** ./frontend/containers/newsSingle/newsSingle.js
 **/